<template>
  <v-wait for="loadMessages">
    <template slot="waiting">
      <p class="eh-secondary-text text-center mt-3">
        Loading messages ...
      </p>
    </template>
    <div class="e-chat">
      <e-chat></e-chat>
    </div>
  </v-wait>
</template>

<script>
	import EChat from "../../elements/chat/chat";
  import {sleep} from "../../../utils/helpers";
  export default {
		name: "eb-chat",
    components: {EChat},
    async beforeMount() {
      this.$wait.start('loadMessages');
      await sleep(1500);
      this.$wait.end('loadMessages');
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/chat/chat.vue